import { DateTime } from 'luxon'
import { TEvent } from '../utils/types'

type EventBannerCandidate = Pick<TEvent, 'id' | 'datetime_start'>

export const getEventBannerToastId = (eventId: string) => `${eventId}-banner`

export const getEventBannerRemainingDuration = (shownAt: number, duration: number, now = Date.now()) =>
    Math.max(1, duration - (now - shownAt))

export const getMostRecentEvent = <T extends EventBannerCandidate>(events: readonly T[]): T | undefined =>
    events.reduce<T | undefined>((mostRecentEvent, event) => {
        if (!mostRecentEvent) return event
        return +DateTime.fromISO(event.datetime_start) > +DateTime.fromISO(mostRecentEvent.datetime_start)
            ? event
            : mostRecentEvent
    }, undefined)

export const getIneligibleEventIds = (
    lastShownEventIds: Iterable<string>,
    eligibleEvents: readonly EventBannerCandidate[]
) => {
    const eligibleEventIds = new Set(eligibleEvents.map((event) => event.id))
    return Array.from(lastShownEventIds).filter((eventId) => !eligibleEventIds.has(eventId))
}

export const shouldShowEventBanner = (lastShownAt: number | undefined, timeUntilEvent: number) =>
    lastShownAt === undefined || (lastShownAt > timeUntilEvent && [0, 1, 5].includes(timeUntilEvent))

export const resolveEventBannerSelection = <T extends EventBannerCandidate>(
    eligibleEvents: readonly T[],
    previouslySelectedEventId?: string
) => {
    const event = getMostRecentEvent(eligibleEvents)
    const selectionChanged = previouslySelectedEventId !== event?.id

    return {
        event,
        selectionChanged,
        toastIdToDismiss:
            previouslySelectedEventId && selectionChanged
                ? getEventBannerToastId(previouslySelectedEventId)
                : undefined,
    }
}
